

















































import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import EditableText, { SaveEventHandler } from "@/containers/EditableText.vue";
import ResetModal from "@/components/modal/ResetModal.vue";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import { USER_ME, CompanyData, GroupData } from "@/graphql/query/user/me";
import { resetMe } from "@/graphql/mutation/resetMe";
import { updateMe } from "@/graphql/mutation/updateMe";
import { toString } from "@/lib/scope";
import { downloadAsFile } from "@/lib/download";
import { ScopeData } from "@/graphql/scopeData";

interface MyData {
  id: string;
  loginId: string;
  email: string;
  name: string;
  scopes: ScopeData[];
  group: GroupData;
  company: CompanyData;
}

@Component({
  components: {
    CButton,
    ResetModal,
    SimpleTable,
    EditableText
  },
  apollo: {
    me: USER_ME
  }
})
export default class MyDetails extends Vue {
  me: MyData | null = null;
  reset: boolean = false;
  resetModal: boolean = false;
  loginIdModal: boolean = false;

  get role(): string {
    return toString(this.me!.scopes, this.me!.group.id);
  }

  async resetPassword() {
    this.reset = true;
    const { data } = await resetMe(this.$apollo, this.me!.id);

    const user = this.me!;
    const email = typeof user.email === "string" ? user.email : "";

    if(!data) throw new Error("データが取得できませんでした")

    const csv = `ユーザー名,権限,メールアドレス,ログインID,パスワード
${user.name},${this.role},${email},${user.loginId},${data.resetMe}
`;
    downloadAsFile(`${user.name}.csv`, "text/csv", csv);
    this.resetModal = false;
  }

  async saveLoginId(handler: SaveEventHandler) {
    handler(async (value: string) => {
      if (!value || value.length > 32) {
        throw new Error("ログインIDは1文字以上10文字以下の半角英数で指定ください。");
      }

      if(!value.match(/^[A-Za-z0-9]*$/)){
        throw new Error("ログインIDは半角英数で指定ください。");
      }

      // 保存
      await updateMe(this.$apollo, {
        userId: this.me!.id,
        loginId: value
      });
      alert("変更しました");
      // クエリ再取得
      await this.$apollo.queries.me.refresh();
    });
  }
}
